import { render } from "./OccupationalSafetyExpertsPage.vue?vue&type=template&id=202337b2&scoped=true"
import script from "./OccupationalSafetyExpertsPage.vue?vue&type=script&lang=js"
export * from "./OccupationalSafetyExpertsPage.vue?vue&type=script&lang=js"

import "./OccupationalSafetyExpertsPage.vue?vue&type=style&index=0&id=202337b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-202337b2"]])

export default __exports__